import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import api from '../utils/api'; 
import '../style.css'
import CircularProgress from '@mui/material/CircularProgress';

const MalfunctionReasonChart = ({range, selectedRegions, setSelectedRegions, selectedDistricts, setSelectedDistricts, monthYear}) => {
    const [loading, setLoading] = useState(true);

    const [malfunctionChartData, setMalfunctionChartData] = useState({
        series: [],
        options: {
            chart: {
                type: 'donut',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }
            },
            labels: [],
            states: {
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'light'
                    }
                }
            },
            legend: {
                position: 'bottom',
                fontSize: '9px',
            },
            title: {
                text: 'Reason for Malfunction'
            },
            plotOptions: {
                pie: {
                    expandOnClick: false
                }
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 400
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        }
    });
    
    useEffect(() => {
        if (range[0] != null) {
            setLoading(true);
            const controller = new AbortController();
            let start_date = new Date(range[0]).toISOString().slice(0, 10);
            let end_date = new Date(range[1]).toISOString().slice(0, 10);
            const monthsParam = monthYear.join(','); 
            api.get("malfunction-reasons/", {
                params: {
                    start: start_date,
                    end: end_date,
                    region:JSON.stringify(selectedRegions),
                    district:JSON.stringify(selectedDistricts),
                    months : monthsParam 
                },
                signal: controller.signal
            }).then(res => {
                const data = JSON.parse(res.data);  // or res.data directly if already JSON
                setMalfunctionChartData(prev => ({
                    series: data.map(d => d.cnt),
                    options: {
                        ...prev.options,
                        labels:data.map(d => d.reasons)
                    }
                }));
            }).catch((err) => {
                console.error('Failed to fetch reports:', err);
            })
            .finally(() => setLoading(false));
            return () => {
                controller.abort();
            };
        }
    }, [monthYear, selectedRegions, selectedDistricts]);

    useEffect(() => {
        // console.log(malfunctionChartData);
    },[malfunctionChartData]);

    return (
        <>
        <div id='wrap'> 
            <div id="chart-malfunction" style={{ minHeight: 352, width: '100%' }}>
                {/* {malfunctionChartData.series.length > 0 && (<ReactApexChart options={malfunctionChartData.options} series={malfunctionChartData.series} type="donut" width={'100%'} />)} */}
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <ReactApexChart
                        key={JSON.stringify(malfunctionChartData.series)}
                        options={malfunctionChartData.options}
                        series={malfunctionChartData.series}
                        type="donut"
                        width={'100%'}
                    />
                )}
            </div>
        </div>
        </>
    );
};

export default MalfunctionReasonChart;